// The sales-rep mascot artwork belonged to a different company and has been removed.
// Kept as a no-op component (same name, props and export) so every call site still works.
export default function RepMascot({ height = 150, pose, style = {}, className = '' }) {
  return null;
}
